import {
  Dimension__compareTo_impl_gsceod2qehgbisv77nv as Dimension__compareTo_impl_gsceod,
  Dimension__toString_impl_o4q1adx82fzjdnbyok as Dimension__toString_impl_o4q1ad,
  Dimension__hashCode_impl_p583vw27ml4nzz2xkra as Dimension__hashCode_impl_p583vw,
  timesx4ey3un7ihw1 as times,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_rem14pbkv8p42gid as get_rem_0,
  minus1paei8txflgx9 as minus,
  plus2opbwe063z9pg as plus,
  get_dp28ag147e4p5cz as get_dp,
  get_px8ok5q0jdway2 as get_px,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { AppState_getInstance1lcg5jamx8e1g as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { lens3m3nj3zkwtu6r as lens } from '../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_wideDimensions() {
  _init_properties_AppDimensions_kt__ajn61o();
  return wideDimensions;
}
var wideDimensions;
function get_narrowDimensions() {
  _init_properties_AppDimensions_kt__ajn61o();
  return narrowDimensions;
}
var narrowDimensions;
function CrowPayDimensions$Companion$live$lambda(it) {
  return Dimension__compareTo_impl_gsceod(it.ebi_1, Companion_getInstance().rgf_1) >= 0 ? get_wideDimensions() : get_narrowDimensions();
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.rgf_1 = get_rem(55);
        var tmp = this;
        var tmp_0 = AppState_getInstance().mbi();
        tmp.sgf_1 = lens(tmp_0, CrowPayDimensions$Companion$live$lambda);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var CrowPayDimensionsClass;
function CrowPayDimensions() {
  if (CrowPayDimensionsClass === VOID) {
    class $ {
      constructor(xlTitleTextSize, titleTextSize, subtitleTextSize, bodyTextSize, smallBodyTextSize, fullIndent, sectionIndent, backgroundIndent, majorColumnSpacing, tabSectionPadding, projectInfoTabsSize, activityTabMinSize, navMenuWidth, pageWidth, wideCollapseWidth, normalCollapseWidth, thinCollapseWidth, buttonRowGap, buttonGap, buttonHorizontalPadding, buttonMinimumWidth, expandButtonSpace, labelSpacing, outlineWidth, cornerRadii, largeImagePreview, smallImagePreview, leftNavWidth, topNavHeight, actionBarHeight) {
        Companion_getInstance();
        this.rg1_1 = xlTitleTextSize;
        this.sg1_1 = titleTextSize;
        this.tg1_1 = subtitleTextSize;
        this.ug1_1 = bodyTextSize;
        this.vg1_1 = smallBodyTextSize;
        this.wg1_1 = fullIndent;
        this.xg1_1 = sectionIndent;
        this.yg1_1 = backgroundIndent;
        this.zg1_1 = majorColumnSpacing;
        this.ag2_1 = tabSectionPadding;
        this.bg2_1 = projectInfoTabsSize;
        this.cg2_1 = activityTabMinSize;
        this.dg2_1 = navMenuWidth;
        this.eg2_1 = pageWidth;
        this.fg2_1 = wideCollapseWidth;
        this.gg2_1 = normalCollapseWidth;
        this.hg2_1 = thinCollapseWidth;
        this.ig2_1 = buttonRowGap;
        this.jg2_1 = buttonGap;
        this.kg2_1 = buttonHorizontalPadding;
        this.lg2_1 = buttonMinimumWidth;
        this.mg2_1 = expandButtonSpace;
        this.ng2_1 = labelSpacing;
        this.og2_1 = outlineWidth;
        this.pg2_1 = cornerRadii;
        this.qg2_1 = largeImagePreview;
        this.rg2_1 = smallImagePreview;
        this.sg2_1 = leftNavWidth;
        this.tg2_1 = topNavHeight;
        this.ug2_1 = actionBarHeight;
      }
      tgf() {
        return Companion_getInstance().rgf_1;
      }
      toString() {
        return 'CrowPayDimensions(xlTitleTextSize=' + Dimension__toString_impl_o4q1ad(this.rg1_1) + ', titleTextSize=' + Dimension__toString_impl_o4q1ad(this.sg1_1) + ', subtitleTextSize=' + Dimension__toString_impl_o4q1ad(this.tg1_1) + ', bodyTextSize=' + Dimension__toString_impl_o4q1ad(this.ug1_1) + ', smallBodyTextSize=' + Dimension__toString_impl_o4q1ad(this.vg1_1) + ', fullIndent=' + Dimension__toString_impl_o4q1ad(this.wg1_1) + ', sectionIndent=' + Dimension__toString_impl_o4q1ad(this.xg1_1) + ', backgroundIndent=' + Dimension__toString_impl_o4q1ad(this.yg1_1) + ', majorColumnSpacing=' + Dimension__toString_impl_o4q1ad(this.zg1_1) + ', tabSectionPadding=' + Dimension__toString_impl_o4q1ad(this.ag2_1) + ', projectInfoTabsSize=' + Dimension__toString_impl_o4q1ad(this.bg2_1) + ', activityTabMinSize=' + Dimension__toString_impl_o4q1ad(this.cg2_1) + ', navMenuWidth=' + Dimension__toString_impl_o4q1ad(this.dg2_1) + ', pageWidth=' + Dimension__toString_impl_o4q1ad(this.eg2_1) + ', wideCollapseWidth=' + Dimension__toString_impl_o4q1ad(this.fg2_1) + ', normalCollapseWidth=' + Dimension__toString_impl_o4q1ad(this.gg2_1) + ', thinCollapseWidth=' + Dimension__toString_impl_o4q1ad(this.hg2_1) + ', buttonRowGap=' + Dimension__toString_impl_o4q1ad(this.ig2_1) + ', buttonGap=' + Dimension__toString_impl_o4q1ad(this.jg2_1) + ', buttonHorizontalPadding=' + Dimension__toString_impl_o4q1ad(this.kg2_1) + ', buttonMinimumWidth=' + Dimension__toString_impl_o4q1ad(this.lg2_1) + ', expandButtonSpace=' + Dimension__toString_impl_o4q1ad(this.mg2_1) + ', labelSpacing=' + Dimension__toString_impl_o4q1ad(this.ng2_1) + ', outlineWidth=' + Dimension__toString_impl_o4q1ad(this.og2_1) + ', cornerRadii=' + Dimension__toString_impl_o4q1ad(this.pg2_1) + ', largeImagePreview=' + Dimension__toString_impl_o4q1ad(this.qg2_1) + ', smallImagePreview=' + Dimension__toString_impl_o4q1ad(this.rg2_1) + ', leftNavWidth=' + Dimension__toString_impl_o4q1ad(this.sg2_1) + ', topNavHeight=' + Dimension__toString_impl_o4q1ad(this.tg2_1) + ', actionBarHeight=' + Dimension__toString_impl_o4q1ad(this.ug2_1) + ')';
      }
      hashCode() {
        var result = Dimension__hashCode_impl_p583vw(this.rg1_1);
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.sg1_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.tg1_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.ug1_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.vg1_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.wg1_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.xg1_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.yg1_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.zg1_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.ag2_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.bg2_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.cg2_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.dg2_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.eg2_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.fg2_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.gg2_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.hg2_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.ig2_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.jg2_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.kg2_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.lg2_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.mg2_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.ng2_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.og2_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.pg2_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.qg2_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.rg2_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.sg2_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.tg2_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.ug2_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CrowPayDimensions()))
          return false;
        if (!equals(this.rg1_1, other.rg1_1))
          return false;
        if (!equals(this.sg1_1, other.sg1_1))
          return false;
        if (!equals(this.tg1_1, other.tg1_1))
          return false;
        if (!equals(this.ug1_1, other.ug1_1))
          return false;
        if (!equals(this.vg1_1, other.vg1_1))
          return false;
        if (!equals(this.wg1_1, other.wg1_1))
          return false;
        if (!equals(this.xg1_1, other.xg1_1))
          return false;
        if (!equals(this.yg1_1, other.yg1_1))
          return false;
        if (!equals(this.zg1_1, other.zg1_1))
          return false;
        if (!equals(this.ag2_1, other.ag2_1))
          return false;
        if (!equals(this.bg2_1, other.bg2_1))
          return false;
        if (!equals(this.cg2_1, other.cg2_1))
          return false;
        if (!equals(this.dg2_1, other.dg2_1))
          return false;
        if (!equals(this.eg2_1, other.eg2_1))
          return false;
        if (!equals(this.fg2_1, other.fg2_1))
          return false;
        if (!equals(this.gg2_1, other.gg2_1))
          return false;
        if (!equals(this.hg2_1, other.hg2_1))
          return false;
        if (!equals(this.ig2_1, other.ig2_1))
          return false;
        if (!equals(this.jg2_1, other.jg2_1))
          return false;
        if (!equals(this.kg2_1, other.kg2_1))
          return false;
        if (!equals(this.lg2_1, other.lg2_1))
          return false;
        if (!equals(this.mg2_1, other.mg2_1))
          return false;
        if (!equals(this.ng2_1, other.ng2_1))
          return false;
        if (!equals(this.og2_1, other.og2_1))
          return false;
        if (!equals(this.pg2_1, other.pg2_1))
          return false;
        if (!equals(this.qg2_1, other.qg2_1))
          return false;
        if (!equals(this.rg2_1, other.rg2_1))
          return false;
        if (!equals(this.sg2_1, other.sg2_1))
          return false;
        if (!equals(this.tg2_1, other.tg2_1))
          return false;
        if (!equals(this.ug2_1, other.ug2_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CrowPayDimensions');
    CrowPayDimensionsClass = $;
  }
  return CrowPayDimensionsClass;
}
function get_AppDimensions() {
  _init_properties_AppDimensions_kt__ajn61o();
  return Companion_getInstance().sgf_1.f2();
}
var properties_initialized_AppDimensions_kt_tw0caq;
function _init_properties_AppDimensions_kt__ajn61o() {
  if (!properties_initialized_AppDimensions_kt_tw0caq) {
    properties_initialized_AppDimensions_kt_tw0caq = true;
    // Inline function 'kotlin.run' call
    var fullIndent = times(get_rem(4), 0.8);
    var sectionIndent = times(get_rem(2), 0.8);
    var pageWidth = get_rem(65);
    wideDimensions = new (CrowPayDimensions())(get_rem_0(1.6), get_rem_0(1.3), get_rem_0(1.1), get_rem_0(0.9), get_rem_0(0.75), fullIndent, sectionIndent, times(minus(fullIndent, sectionIndent), 0.8), times(get_rem(3), 0.8), get_rem_0(0.5), get_rem(25), get_rem(25), get_rem(15), pageWidth, plus(pageWidth, get_rem(13)), pageWidth, minus(pageWidth, times(get_rem(17), 0.8)), get_rem_0(0.7), times(get_dp(10), 0.8), times(get_dp(22), 0.8), times(get_dp(100), 0.8), times(get_dp(5), 0.8), get_dp(5), get_px(1), times(get_dp(3), 0.8), times(get_rem(15), 0.8), times(get_rem(10), 0.8), times(get_rem(10), 0.8), times(get_rem(7), 0.8), times(get_rem_0(4.5), 0.8));
    // Inline function 'kotlin.run' call
    var fullIndent_0 = get_rem(1);
    var sectionIndent_0 = get_rem(1);
    var pageWidth_0 = get_rem(45);
    narrowDimensions = new (CrowPayDimensions())(get_rem_0(1.75), get_rem_0(1.3), get_rem_0(1.1), get_rem_0(0.9), get_rem_0(0.75), fullIndent_0, sectionIndent_0, minus(fullIndent_0, sectionIndent_0), get_rem_0(1.5), get_rem_0(0.5), get_rem(25), get_rem(25), get_rem(15), pageWidth_0, plus(pageWidth_0, get_rem(55)), plus(pageWidth_0, get_rem(35)), pageWidth_0, get_rem_0(0.5), times(get_dp(10), 0.8), times(get_dp(22), 0.8), times(get_dp(100), 0.8), get_dp(4), get_dp(5), get_dp(2), get_dp(3), get_rem_0(8.5), get_rem(5), get_rem(13), get_rem(7), get_rem_0(4.5));
  }
}
//region block: exports
export {
  get_AppDimensions as get_AppDimensions1ckwvsuun6046,
  Companion_getInstance as Companion_getInstance3ks9yb1iyfxr2,
};
//endregion

//# sourceMappingURL=AppDimensions.mjs.map
